module.exports = __webpack_public_path__ + "img/gc_country_flag_au.7eb8aefc.svg";